import React, {
    useState,
    useEffect,
    Component,
    Fragment,
    createRef,
} from "react";
import { connect } from "react-redux";
import { Field } from "react-final-form-html5-validation";
import * as actions from "../../actions";
import SignatureCanvas from "react-signature-canvas";
import DropdownDate from "react-dropdown-date";
import { OnChange } from "react-final-form-listeners";
import { stateList, textField, textareaField } from "../helpers/Form";
import {
    isRequiredText,
    conditionallyRequiredText,
    conditionallyRequiredDate,
    isRequiredDate,
    isRequiredQuestionSelection,
    conditionallyRequiredPhoneNumber,
    isRequiredStateSelection,
    conditionallyRequiredSignature,
    conditionallyRequiredSelection,
    conditionallyRequiredTextarea,
    isRequiredPhoneNumber,
    isRequiredZipCode,
    isRequiredSelectionCheckbox,
    numberValidator,
    conditionallyRequired,
    isRequiredSelection,
    isRequired,
    conditionallyRequiredSelectionCheckbox,
} from "../helpers/Validation";
import { hipaaTextFull } from "../terms/hipaa";
import { questionAnswer } from "../../actions";
import arrowUp from "../../assets/images/arrow-up.png";
import arrowDown from "../../assets/images/arrow-down.png";
import SignatureDate from "../hooks/SignatureDate";
const { JSDOM } = require("jsdom");
const { window } = new JSDOM("");
const $ = require("jquery")(window);

class Step1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gender: null,
            preferredContact: null,
            nuplazidOrderOnFile: null,
            patientSignature: null,
            patientResides: null,
            preferredContactTime: null,
            personalRepresentative: null,
            descriptionOfAuthority: null,
            dob: false,
            dischargeDate: false,
            patientSignatureDate: null,
            personalRepresentativeDate: null,
            hipaaTextBox: false,
        };
    }

    // Used to restore sigs
    componentDidMount() {
        const { patientSignature, personalRepresentative } =
            this.props.questionOptions;

        const options = {
            minWidth: 0.5,
        };
        if (patientSignature) {
            this["patientSignatureRef"].fromDataURL(patientSignature, options);
        }

        if (personalRepresentative) {
            this["personalRepresentativeRef"].fromDataURL(
                personalRepresentative,
                options
            );
        }
    }

    /*clearSigCanvas = (refName) => {
        this[(refName + "Ref")].clear();
    }*/
    clearSigCanvas = (refName) => {
        this[refName + "Ref"].clear();
        console.log("clearSigCanvas refName=" + refName);
        if (refName == "personalRepresentative") {
            this.state.personalRepresentative = false;
            this.state.descriptionOfAuthority = false;
            this.setState({ descriptionOfAuthority: false });
            this.setState({ personalRepresentative: false });
            //this.descriptionOfAuthority = false;
            /* let descriptionOfAuthority = document.getElementsByName("descriptionOfAuthority")[0];
             descriptionOfAuthority.classList.remove("error");
             document.querySelectorAll('.textarea-error').forEach(function(a){
                 a.remove()
             });*/
            //let textareaError = document.getElementsByName("textarea-error")[0];
            //textareaError.style.display = "none";
            //textareaError.remove();
            /* useEffect(() => {
                 // Update the document title using the browser API
                    this.personalRepresentative = true;
                    this.descriptionOfAuthority = true;
               });*/
        }
    };

    storeSigData = (refName) => {
        this.setState({
            ...this.state,
            [refName]: this[refName + "Ref"].getTrimmedCanvas().toDataURL(),
        });
        this.props.questionAnswer(refName, this[refName + "Ref"].toDataURL());
        console.log(this.agreeToHipaaAuthRef);
        if (this.agreeToHipaaAuthRef.current.checked === true) {
            this.props.questionAnswer("hipaa", true);
        }
    };

    toggleTextBox = (name) => {
        this.setState({
            ...this.state,
            [name]: !this.state[name],
        });
        this.hipaaTextBox.current.scrollIntoView({ behavior: "smooth" });
    };

    patientPhoneTwo = createRef();
    patientPhoneThree = createRef();
    caregiverPhoneTwo = createRef();
    caregiverPhoneThree = createRef();
    facilityPhoneTwo = createRef();
    facilityPhoneThree = createRef();
    pharmacyPhoneTwo = createRef();
    pharmacyPhoneThree = createRef();
    hipaaTextBox = createRef();
    caregiverName = createRef();
    agreeToHipaaAuthRef = createRef();

    handleNuplazidOrderOnFileClick(answer) {
        this.props.questionAnswer("nuplazidOrderOnFile", answer);
        sessionStorage.setItem("nuplazidOrderOnFile", answer);
    }

    handlePatientResideClick(answer) {
        console.log("handlePatientResideClick");
        //console.log("answer="+answer);
        this.props.questionAnswer("patientResides", answer);
        sessionStorage.setItem("patientResides", answer);
        var previousNuplazidOrderOnFile = "";
        if (answer == "Contact At Home") {
            var container, inputs, index, i, selectElements;
            previousNuplazidOrderOnFile = sessionStorage.getItem(
                "nuplazidOrderOnFile"
            );
            if (!previousNuplazidOrderOnFile) {
                previousNuplazidOrderOnFile = "";
            }
            sessionStorage.setItem(
                "previousNuplazidOrderOnFile",
                previousNuplazidOrderOnFile
            );
            this.props.questionAnswer("nuplazidOrderOnFile", "didNotOrder");
            sessionStorage.setItem("nuplazidOrderOnFile", "didNotOrder");

            container = document.getElementById("patientResideForm");
            //console.log('container='+container);
            /* $('#patientResideForm').find('input:text').val('');
             $('#patientResideForm').find('select').prop('selectedIndex', 0);
             $('#patientResideForm').find('input:radio').attr("checked", false);
             $('#patientResideForm').find('input:checkbox').attr("checked", false);
             $('#patientResideForm').hide();*/

            if (container) {
                inputs = container.getElementsByTagName("input");
                console.log("inputs.length=" + inputs.length);
                for (index = 0; index < inputs.length; ++index) {
                    console.log(
                        "inputs[" + index + "].value=" + inputs[index].value
                    );
                    if (inputs[index].type == "text") {
                        inputs[index].value = "";
                    } else if (
                        inputs[index].type == "radio" ||
                        inputs[index].type == "checkbox"
                    ) {
                        inputs[index].checked = false;
                    }
                }
                selectElements = container.getElementsByTagName("select");
                for (i = 0; i < selectElements.length; i++) {
                    selectElements[i].selectedIndex = 0;
                }
            }
        } else {
            previousNuplazidOrderOnFile = sessionStorage.getItem(
                "previousNuplazidOrderOnFile"
            );
            if (!previousNuplazidOrderOnFile) {
                previousNuplazidOrderOnFile = "";
            }
            sessionStorage.setItem(
                "nuplazidOrderOnFile",
                previousNuplazidOrderOnFile
            );
            // $('#patientResideForm').show();
        }
        window.scrollTo({
            top: document.getElementById("step2").offsetTop,
            left: 0,
            behavior: "smooth",
        });
    }

    render() {
        const todaysDate = new Date().toLocaleString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
        });
        const { currentStep } = this.props;
        const { hipaaTextBox } = this.state;
        const {
            gender,
            preferredContact,
            nuplazidOrderOnFile,
            patientResides,
            caregiverPhoneOne,
            caregiverPhoneTwo,
            caregiverPhoneThree,
            facilityPhoneOne,
            facilityPhoneTwo,
            facilityPhoneThree,
            pharmacyPhoneOne,
            pharmacyPhoneTwo,
            pharmacyPhoneThree,
            patientPhoneOne,
            patientPhoneTwo,
            patientPhoneThree,
            hipaa,
            personalRepresentative,
            personalRepresentativeCheck = false,
            descriptionOfAuthority,
            dob,
            dischargeDate,
            patientSignatureDate,
            patientSignature,
            personalRepresentativeDate,
            personalRepActive = "#857C7A",
        } = this.props.questionOptions;

        return (
            <Fragment>
                {/* <div class="row">
                    <div class="col-lg-12">
                        <h3 className="euclid">TREATMENT FORM</h3>
                        <p>You can also <a href="/pdf/treatment-form-nuplazid.pdf" target="_blank">download a PDF version of the treatment form</a>&nbsp;to fill out and email to&nbsp;<a href="mailto:acadiaconnect@acadia-pharm.com ">acadiaconnect@acadia-pharm.com</a>.</p>
                    </div>
                </div> */}
                <div class="row spacer-medium">&nbsp;</div>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div
                        className="col-sm-10 col-10 pl-3"
                        style={{ marginTop: "0px" }}
                    >
                        <h3 className="euclid">
                            PATIENT OR RESIDENT INFORMATION
                        </h3>
                        <div className="d-inline-block">
                            *
                            <i class="required-field-indication">
                                &nbsp;Indicates required field.
                            </i>
                        </div>
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>

                <div className="row spacer-medium" ref={this.toTop}>
                    &nbsp;
                </div>
                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="patientFirstName"
                            label="Patient first name*"
                            component={textField}
                            validate={isRequiredText}
                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="patientLastName"
                            label="Patient last name*"
                            placeholder=""
                            component={textField}
                            validate={isRequiredText}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm">
                        <div className="form-group select">
                            <Field
                                name="dob"
                                component="input"
                                defaultValue={dob}
                                validate={isRequiredDate}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            className={
                                                meta.error && meta.touched
                                                    ? "error"
                                                    : "fancy-label"
                                            }
                                            htmlFor="dob"
                                        >
                                            Date of birth*
                                        </label>
                                        <DropdownDate
                                            onDateChange={(date) => {
                                                this.props.questionAnswer(
                                                    "dob",
                                                    date
                                                );
                                            }}
                                            order={
                                                ["month", "day", "year"] // Order of the dropdowns
                                            }
                                            defaultValues={{
                                                month: "Month",
                                                day: "Day",
                                                year: "Year",
                                            }}
                                            selectedDate={dob ? dob : ""}
                                            options={{
                                                yearReverse: true,
                                            }}
                                            classes={{
                                                month:
                                                    meta.error && meta.touched
                                                        ? "dateDropDownMonthClass error"
                                                        : "dateDropDownMonthClass",
                                                day:
                                                    meta.error && meta.touched
                                                        ? "dateDropDownDayClass error"
                                                        : "dateDropDownDayClass",
                                                year:
                                                    meta.error && meta.touched
                                                        ? "dateDropDownYearClass error"
                                                        : "dateDropDownYearClass",
                                            }}
                                            ids={
                                                // optional
                                                {
                                                    year: "dob-select-year",
                                                    month: "dob-select-month",
                                                    day: "dob-select-day",
                                                }
                                            }
                                        />
                                    </Fragment>
                                )}
                            </Field>

                            <Field
                                name="dob"
                                component="input"
                                defaultValue={dob}
                                validate={isRequiredDate}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="col-sm">
                        <Field
                            name="patientAddress"
                            label="Address*"
                            component={textField}
                            validate={isRequiredText}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <Field
                            name="patientCity"
                            label="City*"
                            component={textField}
                            validate={isRequiredText}
                            customMarginBottom="50px"
                        />
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group patient-state-select">
                            <Field
                                name="patientState"
                                component="select"
                                validate={isRequiredStateSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            className={
                                                meta.error && meta.touched
                                                    ? "fancy-label error"
                                                    : "fancy-label"
                                            }
                                            htmlFor="state"
                                            style={{
                                                marginBottom: "0px",
                                                calc: "(100% - 15px)",
                                            }}
                                        >
                                            State*
                                        </label>
                                        <select
                                            {...input}
                                            className={
                                                meta.error && meta.touched
                                                    ? "select-state-css select-css error"
                                                    : "select-state-css select-css"
                                            }
                                            type="select"
                                            style={{
                                                marginTop: "-1px",
                                                height: "41px",
                                                marginBottom: "0px",
                                            }}
                                        >
                                            <option name="" value="">
                                                - Select state -
                                            </option>
                                            {Object.entries(stateList).map(
                                                function (state) {
                                                    return (
                                                        <option
                                                            key={state[0]}
                                                            name="state"
                                                            value={state[0]}
                                                        >
                                                            {state[1]}
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </select>
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <Field
                            name="patientZip"
                            label="ZIP*"
                            placeholder=""
                            component={textField}
                            validate={isRequiredZipCode}
                            maxLength={5}
                            inputMode="numeric"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <div className="form-group">
                            <div className="phone-group">
                                <Field
                                    name="patientPhoneNumber"
                                    component="input"
                                    defaultValue={String(
                                        patientPhoneOne +
                                            patientPhoneTwo +
                                            patientPhoneThree
                                    )}
                                    validate={isRequiredPhoneNumber}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <label
                                                className={
                                                    meta.error && meta.touched
                                                        ? "fancy-label error"
                                                        : "fancy-label"
                                                }
                                            >
                                                Patient phone number*
                                            </label>
                                        </Fragment>
                                    )}
                                </Field>
                                <Field
                                    name="patientPhoneOne"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-area-code error"
                                                        : "form-control inline-phone phone-area-code"
                                                }
                                                type="text"
                                                maxLength="3"
                                                placeholder="123"
                                                inputMode="numeric"
                                            />
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="patientPhoneOne">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "patientPhoneOne",
                                                value
                                            );
                                            if (value.length === 3) {
                                                this.patientPhoneTwo.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="patientPhoneTwo"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-prefix error"
                                                        : "form-control inline-phone phone-prefix"
                                                }
                                                type="text"
                                                maxLength="3"
                                                placeholder="456"
                                                ref={this.patientPhoneTwo}
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="patientPhoneTwo">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "patientPhoneTwo",
                                                value
                                            );
                                            if (value.length === 3) {
                                                this.patientPhoneThree.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="patientPhoneThree"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-line-number error"
                                                        : "form-control inline-phone phone-line-number"
                                                }
                                                type="text"
                                                maxLength="4"
                                                placeholder="7890"
                                                ref={this.patientPhoneThree}
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="patientPhoneThree">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "patientPhoneThree",
                                                value
                                            );
                                        }
                                    }}
                                </OnChange>
                            </div>
                            <Field
                                name="patientPhoneNumber"
                                component="input"
                                defaultValue={String(
                                    patientPhoneOne +
                                        patientPhoneTwo +
                                        patientPhoneThree
                                )}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="form-group">
                            <label>Gender</label>
                            <div className="col pl-0">
                                <div className="radio-field">
                                    <Field
                                        name="gender"
                                        type="radio"
                                        className=""
                                    >
                                        {({ input, meta }) => {
                                            return (
                                                <Fragment>
                                                    <input
                                                        className=""
                                                        id="male"
                                                        name={input.name}
                                                        type="radio"
                                                        onClick={(e) =>
                                                            this.props.questionAnswer(
                                                                "gender",
                                                                "male"
                                                            )
                                                        }
                                                    />
                                                </Fragment>
                                            );
                                        }}
                                    </Field>
                                    <label className="" htmlFor="male">
                                        Male
                                    </label>
                                </div>
                                <div className="radio-field">
                                    <Field
                                        name="gender"
                                        type="radio"
                                        className=""
                                    >
                                        {({ input, meta }) => {
                                            return (
                                                <Fragment>
                                                    <input
                                                        className=""
                                                        id="female"
                                                        name={input.name}
                                                        type="radio"
                                                        onClick={(e) =>
                                                            this.props.questionAnswer(
                                                                "gender",
                                                                "female"
                                                            )
                                                        }
                                                    />
                                                </Fragment>
                                            );
                                        }}
                                    </Field>
                                    <label className="" htmlFor="female">
                                        Female
                                    </label>
                                </div>
                            </div>

                            <Field
                                name="gender"
                                component="input"
                                defaultValue={gender}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row spacer-medium">&nbsp;</div>
                <div className="form-group">
                    <div className="row">
                        <div className="col">
                            <Field
                                name="preferredContact"
                                component="input"
                                defaultValue={preferredContact}
                                validate={isRequiredSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            className={
                                                meta.error && meta.touched
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            Preferred contact*
                                        </label>
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col">
                                        <div className="radio-field">
                                            <Field
                                                name="preferredContact"
                                                component="input"
                                                type="radio"
                                                value="patient"
                                                className=""
                                                id="patient"
                                                onClick={(e) =>
                                                    this.props.questionAnswer(
                                                        "preferredContact",
                                                        "patient"
                                                    )
                                                }
                                            />
                                            <div className="radio-field-label">
                                                <label
                                                    className=""
                                                    htmlFor="patient"
                                                >
                                                    Patient
                                                </label>
                                            </div>
                                        </div>
                                        <div className="radio-field">
                                            <Field
                                                name="preferredContact"
                                                component="input"
                                                type="radio"
                                                value="caregiver"
                                                className=""
                                                id="caregiver"
                                                onClick={(e) =>
                                                    this.props.questionAnswer(
                                                        "preferredContact",
                                                        "caregiver"
                                                    )
                                                }
                                            />
                                            <div className="radio-field-label">
                                                <label
                                                    className=""
                                                    htmlFor="caregiver"
                                                >
                                                    Caregiver
                                                </label>
                                            </div>
                                        </div>
                                        <Field
                                            name="preferredContact"
                                            component="input"
                                            defaultValue={preferredContact}
                                            validate={isRequiredSelection}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        className="form-control full-width-input hidden-field"
                                                        tabIndex="-1"
                                                    />
                                                    {meta.error &&
                                                        meta.touched &&
                                                        meta.error}
                                                </Fragment>
                                            )}
                                        </Field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Field
                            name="caregiverName"
                            label={
                                "Caregiver name" +
                                (preferredContact === "caregiver" ? "*" : "")
                            }
                            type="text"
                            placeholder=""
                            component={textField}
                            key={
                                preferredContact === "caregiver" ||
                                !preferredContact
                                    ? 1
                                    : 0
                            }
                            validate={conditionallyRequiredText(
                                preferredContact === "caregiver"
                            )}
                            forwardRef={this.caregiverName}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-6">
                        <Field
                            name="patientCaregiverEmail"
                            label="Patient/Caregiver email"
                            component={textField}
                            key={
                                preferredContact === "patient" ||
                                !preferredContact
                                    ? 1
                                    : 0
                            }
                            forwardRef={this.patientCaregiverEmail}
                        />
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <Field name="preferredLanguage" component="input">
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            className=""
                                            htmlFor="preferredLanguage"
                                        >
                                            Preferred language, if not English
                                        </label>
                                        <input
                                            style={{ marginTop: "-11px" }}
                                            {...input}
                                            className="form-control full-width-input"
                                            type="text"
                                        />
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row spacer-small" />
                <div className="row spacer-medium mobile" />
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group caregiverPhoneNumber">
                            <Field
                                name="caregiverPhoneNumber"
                                component="input"
                                defaultValue={String(
                                    caregiverPhoneOne +
                                        caregiverPhoneTwo +
                                        caregiverPhoneThree
                                )}
                                key={preferredContact === "caregiver" ? 1 : 0}
                                validate={conditionallyRequiredPhoneNumber(
                                    preferredContact === "caregiver"
                                )}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        <label
                                            className={
                                                meta.error && meta.touched
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            Caregiver phone number{" "}
                                            {preferredContact === "caregiver"
                                                ? "*"
                                                : ""}
                                        </label>
                                    </Fragment>
                                )}
                            </Field>

                            <div className="phone-group">
                                <Field
                                    name="caregiverPhoneOne"
                                    component="input"
                                    validate={conditionallyRequired(
                                        preferredContact === "caregiver"
                                    )}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-area-code error"
                                                        : "form-control inline-phone phone-area-code"
                                                }
                                                type="text"
                                                maxLength="3"
                                                placeholder="123"
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="caregiverPhoneOne">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "caregiverPhoneOne",
                                                value
                                            );
                                            if (value.length === 3) {
                                                this.caregiverPhoneTwo.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="caregiverPhoneTwo"
                                    component="input"
                                    validate={conditionallyRequired(
                                        preferredContact === "caregiver"
                                    )}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-prefix error"
                                                        : "form-control inline-phone phone-prefix"
                                                }
                                                type="text"
                                                maxLength="3"
                                                placeholder="456"
                                                ref={this.caregiverPhoneTwo}
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="caregiverPhoneTwo">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "caregiverPhoneTwo",
                                                value
                                            );
                                            if (value.length === 3) {
                                                this.caregiverPhoneThree.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="caregiverPhoneThree"
                                    component="input"
                                    validate={conditionallyRequired(
                                        preferredContact === "caregiver"
                                    )}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-line-number error"
                                                        : "form-control inline-phone phone-line-number"
                                                }
                                                type="text"
                                                maxLength="4"
                                                placeholder="7890"
                                                ref={this.caregiverPhoneThree}
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="caregiverPhoneThree">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "caregiverPhoneThree",
                                                value
                                            );
                                        }
                                    }}
                                </OnChange>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className="form-group">
                            <Field
                                name="preferredPharmacyName"
                                component="input"
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            className=""
                                            htmlFor="preferredPharmacyName"
                                        >
                                            Preferred pharmacy name
                                        </label>
                                        <input
                                            style={{ marginTop: "-11px" }}
                                            {...input}
                                            className="form-control full-width-input"
                                            type="text"
                                        />
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>

                <div className="form-group pt-4">
                    <Field
                        name="patientResides"
                        component="input"
                        defaultValue={patientResides}
                        //validate={ isRequiredQuestionSelection }
                        validate={isRequiredSelection}
                        // key={(preferredContact === "caregiver" || !preferredContact) ? 1 : 0}
                        //validate={conditionallyRequiredSelectionCheckbox(preferredContact === "caregiver")}
                        //forwardRef={this.patientResides}
                    >
                        {({ input, meta }) => (
                            <Fragment>
                                <label
                                    className={
                                        meta.error && meta.touched
                                            ? "error"
                                            : ""
                                    }
                                >
                                    Patient resides*:
                                </label>
                            </Fragment>
                        )}
                    </Field>

                    <div
                        className="form-group"
                        style={{ top: "10px", right: "-19px" }}
                    >
                        <div className="row">
                            <div className="col pl-0">
                                <div className="radio-field">
                                    <Field
                                        name="patientResides"
                                        component="input"
                                        type="radio"
                                        value="Contact At Home"
                                        className=""
                                        id="preferredContactAtHome"
                                        //key={(preferredContact === "caregiver" || !preferredContact) ? 1 : 0}
                                        //validate={conditionallyRequiredSelection(preferredContact === "caregiver")}
                                        //forwardRef={this.patientResides}
                                        //onClick={(e) => this.props.questionAnswer("patientResides", "Contact At Home")}
                                        onClick={(e) =>
                                            this.handlePatientResideClick(
                                                "Contact At Home"
                                            )
                                        }
                                        validate={isRequiredSelection}
                                        // validate={conditionallyRequiredSelectionCheckbox(preferredContact === "caregiver")}
                                    />
                                    <label
                                        className=""
                                        htmlFor="preferredContactAtHome"
                                    >
                                        At home
                                    </label>
                                </div>
                                <div className="radio-field">
                                    <Field
                                        name="patientResides"
                                        component="input"
                                        type="radio"
                                        value="In Assisted Living"
                                        className=""
                                        id="preferredContactAssistedLiving"
                                        // key={(preferredContact === "caregiver" || !preferredContact) ? 1 : 0}
                                        //  validate={conditionallyRequiredSelection(preferredContact === "caregiver")}
                                        //  forwardRef={this.patientResides}
                                        //onClick={(e) => this.props.questionAnswer("patientResides", "In Assisted Living")}
                                        onClick={(e) =>
                                            this.handlePatientResideClick(
                                                "In Assisted Living"
                                            )
                                        }
                                        validate={isRequiredSelection}
                                        //validate={conditionallyRequiredSelectionCheckbox(preferredContact === "caregiver")}
                                    />
                                    <label
                                        className=""
                                        htmlFor="preferredContactAssistedLiving"
                                    >
                                        Assisted living
                                    </label>
                                </div>
                                <div className="radio-field">
                                    <Field
                                        name="patientResides"
                                        component="input"
                                        type="radio"
                                        value="In a Skilled Nursing Facility/Nursing Home"
                                        className=""
                                        id="preferredContactFacility"
                                        //key={(preferredContact === "caregiver" || !preferredContact) ? 1 : 0}
                                        //validate={conditionallyRequiredSelection(preferredContact === "caregiver")}
                                        // forwardRef={this.patientResides}
                                        // onClick={(e) => this.props.questionAnswer("patientResides", "In a Skilled Nursing Facility/Nursing Home")}
                                        onClick={(e) =>
                                            this.handlePatientResideClick(
                                                "In a Skilled Nursing Facility/Nursing Home"
                                            )
                                        }
                                        validate={isRequiredSelection}
                                        // keyvalidate={conditionallyRequiredSelectionCheckbox(preferredContact === "caregiver")}
                                    />
                                    <label
                                        className=""
                                        htmlFor="preferredContactFacility"
                                    >
                                        Skilled nursing facility/nursing home
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <Field
                                name="patientResides"
                                component="input"
                                defaultValue={patientResides}
                                validate={isRequiredSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row spacer-small" />
                {(patientResides === "In Assisted Living" ||
                    patientResides ===
                        "In a Skilled Nursing Facility/Nursing Home") && (
                    <Fragment>
                        <div id="patientResideForm">
                            <div className="row">
                                <div className="col-sm-6">
                                    <Field
                                        name="facilityName"
                                        label="Facility name*"
                                        component={textField}
                                        validate={isRequiredText}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <Field
                                            name="facilityPhoneNumber"
                                            label="Facility Phone Number*"
                                            component="input"
                                            defaultValue={String(
                                                facilityPhoneOne +
                                                    facilityPhoneTwo +
                                                    facilityPhoneThree
                                            )}
                                            validate={isRequiredPhoneNumber}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        className="form-control full-width-input hidden-field"
                                                        tabIndex="-1"
                                                    />
                                                    <label
                                                        className={
                                                            meta.touched &&
                                                            meta.error
                                                                ? "fancy-label error"
                                                                : "fancy-label"
                                                        }
                                                    >
                                                        Facility phone number*
                                                    </label>
                                                </Fragment>
                                            )}
                                        </Field>
                                        <div className="phone-group">
                                            <Field
                                                name="facilityPhoneOne"
                                                component="input"
                                                validate={isRequired}
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input
                                                            {...input}
                                                            className={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "form-control inline-phone phone-area-code error"
                                                                    : "form-control inline-phone phone-area-code"
                                                            }
                                                            type="text"
                                                            maxLength="3"
                                                            placeholder="123"
                                                            inputMode="numeric"
                                                        />
                                                        {meta.error &&
                                                            meta.touched &&
                                                            meta.error}
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <OnChange name="facilityPhoneOne">
                                                {(value, previous) => {
                                                    if (
                                                        numberValidator(value)
                                                    ) {
                                                        this.props.questionAnswer(
                                                            "facilityPhoneOne",
                                                            value
                                                        );
                                                        if (
                                                            value.length === 3
                                                        ) {
                                                            this.facilityPhoneTwo.current.focus();
                                                        }
                                                    }
                                                }}
                                            </OnChange>
                                            <Field
                                                name="facilityPhoneTwo"
                                                component="input"
                                                validate={isRequired}
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input
                                                            {...input}
                                                            className={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "form-control inline-phone phone-prefix error"
                                                                    : "form-control inline-phone phone-prefix"
                                                            }
                                                            type="text"
                                                            maxLength="3"
                                                            placeholder="456"
                                                            ref={
                                                                this
                                                                    .facilityPhoneTwo
                                                            }
                                                            inputMode="numeric"
                                                        />
                                                        {meta.error &&
                                                            meta.touched &&
                                                            meta.error}
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <OnChange name="facilityPhoneTwo">
                                                {(value, previous) => {
                                                    if (
                                                        numberValidator(value)
                                                    ) {
                                                        this.props.questionAnswer(
                                                            "facilityPhoneTwo",
                                                            value
                                                        );
                                                        if (
                                                            value.length === 3
                                                        ) {
                                                            this.facilityPhoneThree.current.focus();
                                                        }
                                                    }
                                                }}
                                            </OnChange>
                                            <Field
                                                name="facilityPhoneThree"
                                                component="input"
                                                validate={isRequired}
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input
                                                            {...input}
                                                            className={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "form-control inline-phone phone-line-number error"
                                                                    : "form-control inline-phone phone-line-number"
                                                            }
                                                            type="text"
                                                            maxLength="4"
                                                            placeholder="7890"
                                                            ref={
                                                                this
                                                                    .facilityPhoneThree
                                                            }
                                                            inputMode="numeric"
                                                        />
                                                        {meta.error &&
                                                            meta.touched &&
                                                            meta.error}
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <OnChange name="facilityPhoneThree">
                                                {(value, previous) => {
                                                    if (
                                                        numberValidator(value)
                                                    ) {
                                                        this.props.questionAnswer(
                                                            "facilityPhoneThree",
                                                            value
                                                        );
                                                    }
                                                }}
                                            </OnChange>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Field
                                        name="facilityAddress"
                                        label="Address"
                                        component={textField}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <Field
                                            name="facilityCity"
                                            label="City"
                                            component={textField}
                                            //validate={isRequiredText}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <Field
                                                name="facilityState"
                                                component="select"
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <label htmlFor="facilityState">
                                                            State
                                                        </label>
                                                        <select
                                                            {...input}
                                                            className="select-state-css select-css"
                                                            type="select"
                                                            style={{
                                                                marginTop:
                                                                    "-10px",
                                                                marginBottom:
                                                                    "50px",
                                                                height: "38px",
                                                            }}
                                                        >
                                                            <option
                                                                name=""
                                                                value=""
                                                            >
                                                                - Select state -
                                                            </option>
                                                            {Object.entries(
                                                                stateList
                                                            ).map(function (
                                                                state
                                                            ) {
                                                                return (
                                                                    <option
                                                                        key={
                                                                            state[0]
                                                                        }
                                                                        name="state"
                                                                        value={
                                                                            state[0]
                                                                        }
                                                                    >
                                                                        {
                                                                            state[1]
                                                                        }
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                        {meta.error &&
                                                            meta.touched &&
                                                            meta.error}
                                                    </Fragment>
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <Field
                                            name="facilityZipCode"
                                            label="ZIP"
                                            component={textField}
                                            maxLength={5}
                                            inputMode="numeric"
                                            customMarginBottom="30px"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6 facilityContactName">
                                    <Field
                                        name="facilityContactName"
                                        label="Facility contact name"
                                        component={textField}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <Field
                                        name="jobTitle"
                                        label="Job title"
                                        component={textField}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <Field
                                        name="pharmacyName"
                                        label="Pharmacy name"
                                        component={textField}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <label>Pharmacy phone number</label>
                                        <div
                                            className="phone-group"
                                            style={{
                                                marginTop: "-10px",
                                                height: "38px",
                                            }}
                                        >
                                            <Field
                                                name="pharmacyPhoneOne"
                                                component="input"
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input
                                                            {...input}
                                                            className="form-control inline-phone"
                                                            type="text"
                                                            maxLength="3"
                                                            placeholder="123"
                                                            inputMode="numeric"
                                                        />
                                                        {meta.error &&
                                                            meta.touched &&
                                                            meta.error}
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <OnChange name="pharmacyPhoneOne">
                                                {(value, previous) => {
                                                    if (
                                                        numberValidator(value)
                                                    ) {
                                                        this.props.questionAnswer(
                                                            "pharmacyPhoneOne",
                                                            value
                                                        );
                                                        if (
                                                            value.length === 3
                                                        ) {
                                                            this.pharmacyPhoneTwo.current.focus();
                                                        }
                                                    }
                                                }}
                                            </OnChange>
                                            <Field
                                                name="pharmacyPhoneTwo"
                                                component="input"
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input
                                                            {...input}
                                                            className="form-control inline-phone"
                                                            type="text"
                                                            maxLength="3"
                                                            placeholder="456"
                                                            ref={
                                                                this
                                                                    .pharmacyPhoneTwo
                                                            }
                                                            inputMode="numeric"
                                                        />
                                                        {meta.error &&
                                                            meta.touched &&
                                                            meta.error}
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <OnChange name="pharmacyPhoneTwo">
                                                {(value, previous) => {
                                                    if (
                                                        numberValidator(value)
                                                    ) {
                                                        this.props.questionAnswer(
                                                            "pharmacyPhoneTwo",
                                                            value
                                                        );
                                                        if (
                                                            value.length === 3
                                                        ) {
                                                            this.pharmacyPhoneThree.current.focus();
                                                        }
                                                    }
                                                }}
                                            </OnChange>
                                            <Field
                                                name="pharmacyPhoneThree"
                                                component="input"
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input
                                                            {...input}
                                                            className="form-control inline-phone"
                                                            type="text"
                                                            maxLength="4"
                                                            placeholder="7890"
                                                            ref={
                                                                this
                                                                    .pharmacyPhoneThree
                                                            }
                                                            inputMode="numeric"
                                                        />
                                                        {meta.error &&
                                                            meta.touched &&
                                                            meta.error}
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <OnChange name="pharmacyPhoneThree">
                                                {(value, previous) => {
                                                    if (
                                                        numberValidator(value)
                                                    ) {
                                                        this.props.questionAnswer(
                                                            "pharmacyPhoneThree",
                                                            value
                                                        );
                                                    }
                                                }}
                                            </OnChange>
                                        </div>
                                        <Field
                                            name="pharmacyPhoneNumber"
                                            component="input"
                                            defaultValue={String(
                                                pharmacyPhoneOne +
                                                    pharmacyPhoneTwo +
                                                    pharmacyPhoneThree
                                            )}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        className="form-control full-width-input hidden-field"
                                                        tabIndex="-1"
                                                    />
                                                    {meta.error &&
                                                        meta.touched &&
                                                        meta.error}
                                                </Fragment>
                                            )}
                                        </Field>
                                    </div>
                                </div>
                            </div>
                            <div className="row spacer-medium" />
                            <div className="form-group">
                                <div className="row">
                                    <div className="col">
                                        <Field
                                            name="nuplazidOrderOnFile"
                                            component="input"
                                            defaultValue={nuplazidOrderOnFile}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <label className="">
                                                        NUPLAZID order on file
                                                    </label>
                                                </Fragment>
                                            )}
                                        </Field>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col">
                                                    <div className="radio-field">
                                                        <Field
                                                            name="nuplazidOrderOnFile"
                                                            component="input"
                                                            type="radio"
                                                            value="didOrder"
                                                            className=""
                                                            id="didOrder"
                                                            onClick={(e) =>
                                                                this.handleNuplazidOrderOnFileClick(
                                                                    "didOrder"
                                                                )
                                                            }
                                                        />
                                                        <div className="radio-field-label">
                                                            <label
                                                                className=""
                                                                htmlFor="yes"
                                                            >
                                                                Yes
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="radio-field">
                                                        <Field
                                                            name="nuplazidOrderOnFile"
                                                            component="input"
                                                            type="radio"
                                                            value="didNotOrder"
                                                            className=""
                                                            id="didNotOrder"
                                                            onClick={(e) =>
                                                                this.handleNuplazidOrderOnFileClick(
                                                                    "didNotOrder"
                                                                )
                                                            }
                                                        />
                                                        <div className="radio-field-label">
                                                            <label
                                                                className=""
                                                                htmlFor="n"
                                                            >
                                                                No
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <Field
                                                        name="nuplazidOrderOnFile"
                                                        component="input"
                                                        defaultValue={
                                                            nuplazidOrderOnFile
                                                        }
                                                    >
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <input
                                                                    {...input}
                                                                    type="text"
                                                                    className="form-control full-width-input hidden-field"
                                                                    tabIndex="-1"
                                                                />
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="relative form-group"
                                style={{
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                }}
                            >
                                <Field
                                    className="form-control full-width-input"
                                    type="checkbox"
                                    name="coveredUnderMedicare"
                                    key={
                                        hipaa ||
                                        descriptionOfAuthority ||
                                        patientSignature ||
                                        patientSignatureDate
                                            ? 1
                                            : 0
                                    }
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <div className="row">
                                                <div className="col checkbox-container">
                                                    <label className="acadia-checkbox">
                                                        <input
                                                            ref={
                                                                this
                                                                    .coveredUnderMedicare
                                                            }
                                                            {...input}
                                                            type="checkbox"
                                                            style={{
                                                                left: "0px",
                                                            }}
                                                        />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <label className="mobile-label">
                                                        <span className="hipaa-agree">
                                                            Checking this box if
                                                            your resident is
                                                            currently covered
                                                            under Medicare
                                                            Part&nbsp;A
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="coveredUnderMedicare">
                                    {(value, previous) => {
                                        this.props.questionAnswer(
                                            "hipaa",
                                            value
                                        );
                                        this.setState({
                                            ...this.state,
                                            patientSignature: value,
                                            personalRepresentative: !value,
                                        });
                                    }}
                                </OnChange>
                            </div>
                            <div className="row">
                                <div className="col-sm">
                                    <div className="form-group select">
                                        <Field
                                            name="dischargeDate"
                                            component="input"
                                            defaultValue={dischargeDate}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <label
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "error"
                                                                : "fancy-label"
                                                        }
                                                        htmlFor="dischargeDate"
                                                    >
                                                        Expected discharge date
                                                    </label>
                                                    <DropdownDate
                                                        startDate={"2022-09-23"}
                                                        endDate={"2029-01-01"}
                                                        onDateChange={(
                                                            date
                                                        ) => {
                                                            this.props.questionAnswer(
                                                                "dischargeDate",
                                                                date
                                                            );
                                                        }}
                                                        order={
                                                            [
                                                                "month",
                                                                "day",
                                                                "year",
                                                            ] // Order of the dropdowns
                                                        }
                                                        defaultValues={{
                                                            month: "Month",
                                                            day: "Day",
                                                            year: "Year",
                                                        }}
                                                        selectedDate={
                                                            dischargeDate
                                                                ? dischargeDate
                                                                : ""
                                                        }
                                                        options={{
                                                            yearReverse: true,
                                                        }}
                                                        classes={{
                                                            month:
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "dateDropDownMonthClass error"
                                                                    : "dateDropDownMonthClass",
                                                            day:
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "dateDropDownDayClass error"
                                                                    : "dateDropDownDayClass",
                                                            year:
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "dateDropDownYearClass error"
                                                                    : "dateDropDownYearClass",
                                                        }}
                                                        ids={
                                                            // optional
                                                            {
                                                                year: "dd-select-year",
                                                                month: "dd-select-month",
                                                                day: "dd-select-day",
                                                            }
                                                        }
                                                    />
                                                </Fragment>
                                            )}
                                        </Field>

                                        <Field
                                            name="discharge-date"
                                            component="input"
                                            defaultValue={dischargeDate}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        className="form-control full-width-input hidden-field"
                                                        tabIndex="-1"
                                                    />
                                                    {meta.error &&
                                                        meta.touched &&
                                                        meta.error}
                                                </Fragment>
                                            )}
                                        </Field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}

                <div className="row spacer-small" />

                <div className="hipaa signature">
                    <h3 ref={this.hipaaTextBox}>Patient HIPAA Signature</h3>
                    <p>
                        <i>Please read before signing</i>
                    </p>
                    <div className="row spacer-small" />
                    <div
                        className={
                            "scroll-terms " +
                            (hipaaTextBox ? "expanded" : "condensed")
                        }
                    >
                        {hipaaTextFull}
                    </div>
                    <button
                        className="btn no-outline"
                        onClick={() => this.toggleTextBox("hipaaTextBox")}
                        type="button"
                    >
                        SEE{" "}
                        {hipaaTextBox ? (
                            <Fragment>
                                LESS
                                <img
                                    className="arrow"
                                    src={arrowUp}
                                    alt="arrrow"
                                />
                            </Fragment>
                        ) : (
                            <Fragment>
                                MORE
                                <img
                                    className="arrow"
                                    src={arrowDown}
                                    alt="arrrow"
                                />
                            </Fragment>
                        )}
                    </button>
                    <div className="row spacer-small" />
                    <div
                        className="relative form-group iphone11-checkboxes-left-15px"
                        style={{ marginTop: "20px", marginBottom: "20px" }}
                    >
                        <Field
                            className="form-control full-width-input"
                            type="checkbox"
                            name="agreeToHipaaAuth"
                            key={
                                hipaa ||
                                descriptionOfAuthority ||
                                patientSignature ||
                                patientSignatureDate
                                    ? 1
                                    : 0
                            }
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <div className="row">
                                        <div className="col-2 col-md-1">
                                            <label className="acadia-checkbox">
                                                <input
                                                    ref={
                                                        this.agreeToHipaaAuthRef
                                                    }
                                                    {...input}
                                                    type="checkbox"
                                                    style={{ left: "0px" }}
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-10 col-md-11 pl-0">
                                            <label className="mobile-label">
                                                <span className="hipaa-agree">
                                                    I have read and agree to
                                                    HIPAA authorization
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    {meta.error && meta.touched && meta.error}
                                </Fragment>
                            )}
                        </Field>
                        <OnChange name="agreeToHipaaAuth">
                            {(value, previous) => {
                                this.props.questionAnswer("hipaa", value);
                                this.setState({
                                    ...this.state,
                                    patientSignature: value,
                                    personalRepresentative: !value,
                                });
                            }}
                        </OnChange>
                    </div>
                    <div className="relative form-group">
                        <label htmlFor="patientSignature">
                            Patient signature
                        </label>
                        <SignatureCanvas
                            penColor="black"
                            canvasProps={{
                                height: 200,
                                className:
                                    personalRepresentative === true
                                        ? "sig-canvas inactive"
                                        : "sig-canvas active",
                            }}
                            onEnd={() => this.storeSigData("patientSignature")}
                            ref={(ref) => {
                                this.patientSignatureRef = ref;
                            }}
                            clearOnResize={false}
                        />
                        <button
                            type="button"
                            className="canvas-clear"
                            onClick={() =>
                                this.clearSigCanvas("patientSignature")
                            }
                        >
                            CLEAR
                        </button>
                        <Field
                            name="patientSignature"
                            defaultValue={patientSignature}
                            //validate={conditionallyRequiredSignature(hipaa)}
                            key={
                                hipaa ||
                                descriptionOfAuthority ||
                                patientSignature ||
                                patientSignatureDate
                                    ? 1
                                    : 0
                            }
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input
                                        {...input}
                                        type="text"
                                        className="form-control full-width-input hidden-field"
                                        tabIndex="-1"
                                    />
                                    {meta.error && meta.touched && meta.error}
                                </Fragment>
                            )}
                        </Field>
                        <SignatureDate forDate="patientSignature" />
                    </div>
                    <div
                        className="relative form-group mt-20px-mobile mb-0px-mobile"
                        style={{ marginTop: "40px" }}
                    >
                        <Field
                            className="form-control full-width-input temp"
                            type="checkbox"
                            name="personalRepresentativeCheck"
                            component="input"
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <div class="row">
                                        <div class="col-2 col-md-1">
                                            <label className="acadia-checkbox">
                                                <input
                                                    ref={
                                                        this.agreeToHipaaAuthRef
                                                    }
                                                    {...input}
                                                    type="checkbox"
                                                    style={{ left: "0px" }}
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="col-10 col-md-11 pl-0">
                                            <label class="mobile-label">
                                                <span
                                                    className="hipaa-agree"
                                                    style={{
                                                        color: personalRepActive,
                                                    }}
                                                >
                                                    {personalRepresentativeCheck ===
                                                    false
                                                        ? "I would like to authorize a personal representative"
                                                        : "I would like to authorize a personal representative*"}
                                                </span>
                                            </label>
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </div>
                                    </div>
                                </Fragment>
                            )}
                        </Field>
                        <OnChange name="personalRepresentativeCheck">
                            {(value, previous) => {
                                this.props.questionAnswer(
                                    "personalRepActive",
                                    value === true ? "#3286A0" : "#857C7A"
                                );
                                this.props.questionAnswer(
                                    "personalRepresentativeCheck",
                                    value
                                );
                                this.setState({
                                    ...this.state,
                                    patientSignature: !value,
                                    personalRepresentative: value,
                                });
                            }}
                        </OnChange>
                    </div>
                    <div className="relative form-group">
                        <label
                            className={
                                personalRepresentativeCheck === true
                                    ? "sig-canvas active"
                                    : "sig-canvas inactive"
                            }
                            htmlFor="personalRepresentative"
                        >
                            {" "}
                            {personalRepresentativeCheck === false
                                ? "Personal representative signature"
                                : "Personal representative signature*"}
                        </label>

                        <SignatureCanvas
                            penColor="black"
                            canvasProps={{
                                height: 200,
                                className:
                                    personalRepresentative === true
                                        ? "sig-canvas active"
                                        : "sig-canvas inactive",
                            }}
                            onEnd={() =>
                                this.storeSigData("personalRepresentative")
                            }
                            ref={(ref) => {
                                this.personalRepresentativeRef = ref;
                            }}
                            clearOnResize={false}
                        />
                        <button
                            type="button"
                            className="canvas-clear"
                            onClick={() =>
                                this.clearSigCanvas("personalRepresentative")
                            }
                        >
                            CLEAR
                        </button>
                        <Field
                            name="personalRepresentative"
                            defaultValue={personalRepresentative}
                            component="input"
                            validate={conditionallyRequiredSignature(
                                personalRepresentativeCheck
                            )}
                            key={personalRepresentativeCheck ? 1 : 0}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input
                                        {...input}
                                        type="text"
                                        className="form-control full-width-input hidden-field"
                                        tabIndex="-1"
                                    />
                                    {meta.error && meta.touched && meta.error}
                                </Fragment>
                            )}
                        </Field>
                        <SignatureDate forDate="personalRepresentative" />
                    </div>

                    <Field
                        name="descriptionOfAuthority"
                        label="Description of authority"
                        component={textareaField}
                        validate={conditionallyRequiredTextarea(
                            personalRepresentative || descriptionOfAuthority
                                ? 1
                                : 0
                        )}
                        key={
                            personalRepresentative || descriptionOfAuthority
                                ? 1
                                : 0
                        }
                        customInputClass={{
                            backgroundColor: "#ecebeb",
                            borderColor: "#a79c9a",
                            borderStyle: "none none solid",
                        }}
                        customLabelClass={
                            personalRepresentative === true
                                ? "label sig-canvas active"
                                : "label sig-canvas inactive"
                        }
                    />
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
};

export default connect(mapStateToProps, actions)(Step1);
